module.exports = __webpack_public_path__ + "img/w1.5737b8b1.svg";